<template>
  <article>
    <div class="firstPic leftTextArea">
      <div class="textHolder">
        <h2>Energetische Behandelingen</h2>
        <p>
          Tijdens de energetische behandeling gaan we ons meer focussen op de
          emotionele blokkades. Met de crèmes van Go-4-balance in combinatie met
          therapeutische begeleiding en massage gaan we samen aan de slag. Zo
          ervaren we ondersteuning op emotioneel vlak alsook lichamelijke
          ontspanning en coaching.
        </p>
      </div>
      <img
        :src="energetisch"
        alt="Energetische behandelingen"
        class="picHolder"
      />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Enjoy - Water</h2>
        <p>
          Voor meer vreugde en als ondersteuning bij stress. De verzorging
          focust op het vertrouwen van je buikgevoel. Brengt ontspanning bij
          stress en helpt de natuurlijke weerstand te verbeteren. Het brengt je
          opnieuw in je kracht en leert je opnieuw te vertrouwen op je
          buikgevoel.
        </p>
        <ul>
          <li>Coaching gesprek met thee</li>
          <li>
            Gelaatsmassage, kruinmassage, schouder-& nekmassage met Yon-Ka crème
          </li>
          <li>Energetische voetmassage en handmassage</li>
          <li>€60 per 60min</li>
        </ul>
      </div>
      <img :src="enjoy" alt="enjoy" class="picHolder" />
    </div>

    <div class="leftTextArea">
      <div class="textHolder">
        <h2>Trust - Aarde</h2>
        <p>
          Voor meer rust. Werkt kalmerend. De verzorging focust op het
          terugvinden van rust en het loslaten van spanningen. Op deze manier
          ben je meer in staat om opnieuw te ontspannen. Zeer zinvol om
          verwerkingsprocessen te ondersteunen.
        </p>
        <ul>
          <li>Coaching gesprek met thee</li>
          <li>
            Gelaatsmassage, kruinmassage, schouder-& nekmassage met Yon-Ka crème
          </li>
          <li>Energetische voetmassage en handmassage</li>
          <li>€60 per 60min</li>
        </ul>
      </div>
      <img :src="trust" alt="trust" class="picHolder" />
    </div>

    <div class="rightTextArea">
      <div class="textHolder">
        <h2>Empower - Vuur</h2>
        <p>
          Voor meer energie en vitaliteit. Stimuleert je. De verzorging focust
          zich op het geven van meer energie en is geschikt bij geestelijke druk
          of neerslachtigheid. Wakkert jouw vuur weer aan.
        </p>
        <ul>
          <li>Coaching gesprek met thee</li>
          <li>
            Gelaatsmassage, kruinmassage, schouder-& nekmassage met Yon-Ka crème
          </li>
          <li>Energetische voetmassage en handmassage</li>
          <li>€60 per 60min</li>
        </ul>
      </div>
      <img :src="empower" alt="empower" class="picHolder" />
    </div>

    <div class="lastPic leftTextArea">
      <div class="textHolder">
        <h2>Focus - Lucht</h2>
        <p>
          Voor meer concentratie en structuur. De verzorging focust op het
          helder denken, brengt overzicht en zorgt bovendien voor een goed
          humeur. Geeft een helder hoofd. Brengt helderheid en klare visie.
        </p>
        <ul>
          <li>Coaching gesprek met thee</li>
          <li>
            Gelaatsmassage, kruinmassage, schouder-& nekmassage met Yon-Ka crème
          </li>
          <li>Energetische voetmassage en handmassage</li>
          <li>€60 per 60min</li>
        </ul>
      </div>
      <img :src="focus" alt="focus" class="picHolder" />
    </div>
  </article>
</template>

<script>
import energetisch from '../assets/energetisch.webp';
import trust from '../assets/trust.webp';
import empower from '../assets/empower.webp';
import focus from '../assets/focus.webp';
import enjoy from '../assets/enjoy.webp';
export default {
  name: 'Energetisch',
  data() {
      return {
        trust: trust,
        empower: empower,
        focus: focus,
        enjoy: enjoy,
        energetisch: energetisch,
      }
    },
};
</script>

<style lang="scss" scoped>
</style>
